import "./MobileFooter.scss";
import { Link } from "react-router-dom";
import IGLogo from "../assets/global/ig-logo.png";
import FBLogo from "../assets/global/fb-logo.png";
import { FooterLogo } from "../assets/global/Icons";
import { IG_URL, FB_URL, CURR_YEAR } from "../common/constants";

function MobileFooter() {
  return (
    <footer className="mobile-footer">
      <div className="mobile-footer__container">
        <div>
          <p>Mountain View, CA</p>
          <p>408-800-2092</p>
          <p>
            <a href="mailto:connie@conniescakerie.com">
              connie@conniescakerie.com
            </a>
          </p>
        </div>
        <Link to="/">
          <FooterLogo className="mobile-footer__logo" />
        </Link>
      </div>
      <div className="mobile-footer__socials">
        <a href={IG_URL} target="_blank" rel="noopener noreferrer">
          <img src={IGLogo} className="mobile-footer__socials-logo" />
        </a>
        <a href={FB_URL} target="_blank" rel="noopener noreferrer">
          <img src={FBLogo} className="mobile-footer__socials-logo" />
        </a>
      </div>
      <p className="mobile-footer__copyright">
        &copy; {CURR_YEAR} Connie's Cakerie. All rights reserved.
      </p>
    </footer>
  );
}

export default MobileFooter;
